import type { Gym } from "../api/hooks";
import { gymMapEmbedUrl } from "../lib/maps";

// Plan d'accès Google Maps de la salle sélectionnée dans le formulaire de contact.
// iframe sans clé API (voir gymMapEmbedUrl) — chargée à la demande.
export function GymMap({ gym }: { gym: Gym }) {
  return (
    <iframe
      title={`Plan d'accès — ${gym.name}`}
      src={gymMapEmbedUrl(gym)}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="aspect-[4/3] w-full rounded-md border border-ink-200"
    />
  );
}
